import { render, staticRenderFns } from "./SurveyQuestionTabLinks.vue?vue&type=template&id=2bdc9bd4"
import script from "./SurveyQuestionTabLinks.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports